import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { TypeStyle } from '../TypeStyle';
const BreadcrumbLink = styled.a `
  position: relative;
  text-decoration: underline;
  text-decoration-thickness: 0.5px;
  text-underline-offset: 1.5px;
  padding-right: 14px;
  color: ${o => o.theme.color.text.secondary.on.background};

  &:hover {
    color: ${o => o.theme.color.text.primary.on.background};
  }

  &:after {
    content: '•';
    position: absolute;
    color: ${o => o.theme.color.text.secondary.on.background};
    right: 5px;
  }
`;
const BreadcrumbsWrapper = styled.ol `
  display: flex;
  flex-wrap: wrap;
`;
const BreadcrumbsTextLi = styled.li `
  ${TypeStyle.css.headlineMicro};
  display: flex;
  white-space: nowrap;

  &:last-child a:after {
    content: '';
  }
`;
export const Breadcrumbs = ({ children, ...rest }) => {
    return (_jsx("nav", { ...rest, children: _jsx(BreadcrumbsWrapper, { children: children }) }));
};
export const Breadcrumb = ({ as, children, currentPage = false, ...props }) => {
    return (_jsx(BreadcrumbsTextLi, { children: _jsx(BreadcrumbLink, { as: as, ...props, "aria-current": currentPage ? 'page' : undefined, "$currentPage": currentPage, children: children }) }));
};
//# sourceMappingURL=Breadcrumbs.js.map